import { compareUnorderedArrays } from '../../../utils/arrayUtils';
import { NO_UPDATE_ERROR } from '../../../utils/formValidation/commonErrorConstants';
import {
    getCharMinMessage,
    getReqMessage
} from '../../../utils/formValidation/errorMessageFunctions';
import { validateEmail } from '../../../utils/formValidation/validationFunctions';

export const MIN_OTHER_LANGUAGE = 3;
export const MAX_OTHER_LANGUAGE = 100;

export const validate = (
    newEntry,
    initialEntry,
    otherFirstLanguageId,
    otherDeliveredLanguageId
) => {
    let newErrors = {};

    newErrors = validateEmail(
        newEntry.referringOfficerEmailAddress,
        newErrors,
        'referringOfficerEmailAddress'
    );

    if (newEntry.firstLanguageId === otherFirstLanguageId) {
        if (!newEntry.otherFirstLanguage?.length)
            newErrors = {
                ...newErrors,
                otherFirstLanguage: {
                    error: true,
                    message: getReqMessage('Other First language')
                }
            };
        else if (newEntry.otherFirstLanguage?.length < MIN_OTHER_LANGUAGE)
            newErrors = {
                ...newErrors,
                otherFirstLanguage: {
                    error: true,
                    message: getCharMinMessage('Other First language', MIN_OTHER_LANGUAGE)
                }
            };
    }

    if (newEntry.deliveredLanguageId === otherDeliveredLanguageId) {
        if (!newEntry.otherDeliveredLanguage?.length)
            newErrors = {
                ...newErrors,
                otherDeliveredLanguage: {
                    error: true,
                    message: getReqMessage('Other Delivered language')
                }
            };
        else if (newEntry.otherDeliveredLanguage?.length < MIN_OTHER_LANGUAGE)
            newErrors = {
                ...newErrors,
                otherDeliveredLanguage: {
                    error: true,
                    message: getCharMinMessage('Other Delivered language', MIN_OTHER_LANGUAGE)
                }
            };
    }

    const isSame = compareUnorderedArrays(Object.values(initialEntry), Object.values(newEntry));
    if (isSame) {
        newErrors = {
            ...newErrors,
            button: {
                error: true,
                message: NO_UPDATE_ERROR
            }
        };
    }

    return { newErrors };
};
